import React, { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'

import { createBrief } from '@disco/state-management/reducers/entities/briefs'
import {
  getConstanceSettings,
  getUser,
} from '@disco/state-management/selectors/user'
import captureError from '@disco/utils/captureError'
import { getUserDisplayName } from '@disco/utils/string-utils'

import Spinner from 'components/ui/spinner'

import { useDispatch, useSelector } from 'hooks/use-redux'

const BriefEditorNewPageComponent = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const user = useSelector(getUser)
  const constanceSettings = useSelector(getConstanceSettings)
  const briefWorkflowV2Enabled = constanceSettings?.BRIEF_WORKFLOW_V2 || false
  const [searchParams] = useSearchParams()

  const handleCreateBrief = async () => {
    const projectId = searchParams.get('projectId')
    try {
      const newBrief = await dispatch(
        createBrief({
          name: 'New Brief',
          recipients_list: [],
          sender_name: getUserDisplayName(user),
          sender_email: user?.email ?? '',
          template_data: {
            subject: '',
          },
          // @ts-expect-error TODO: check if backend expect projectId or project object?
          project: projectId ? parseInt(projectId) : undefined,
          // Set default open status for V2 workflow
          is_open: briefWorkflowV2Enabled ? true : undefined,
        }),
      ).unwrap()

      const redirectUrl = briefWorkflowV2Enabled
        ? `/brief-editor-v2/${newBrief.id}`
        : `/brief-editor/${newBrief.id}/content`

      navigate(redirectUrl, { replace: true })
    } catch (err) {
      navigate('/', { replace: true })
      captureError(err)
    }
  }
  useEffect(() => {
    if (user?.loggedIn) handleCreateBrief()
  }, [user])

  return <Spinner />
}

export const BriefEditorNewPage = BriefEditorNewPageComponent
